import React from 'react';
import { Select, MenuItem, FormControl, Radio } from '@mui/material';
import { styled } from '@mui/material/styles';

const CustomRadio = styled(Radio)({
  color: '#14151C',
  '&.Mui-checked': {
    color: '#14151C'
  }
});

export const VerifyDropdown = ({
  isEnable,
  isVerifiedByAdmin,
  rowId,
  onVerifyChange
}: any) => {
  const handleChange = (event: any) => {
    onVerifyChange(
      rowId,
      event.target.value,
      event.target.value === 'verified'
    );
  };

  const actualValue = isVerifiedByAdmin ? 'verified' : 'unverified';

  const renderValue = (selected: any) => {
    if (selected === 'verified') return 'Verified';
    if (selected === 'unverified') return 'Unverified';
    return '';
  };

  return (
    <FormControl
      size='small'
      style={{
        margin: 0,
        padding: 0,
        height: 'auto',
        minHeight: 'auto',
        width: '150px'
      }}
    >
      <Select
        value={actualValue}
        onChange={handleChange}
        displayEmpty
        variant='standard'
        disableUnderline
        style={{
          margin: 0,
          padding: 0,
          height: '10px',
          width: '100%'
        }}
        disabled={isEnable}
        inputProps={{
          style: {
            margin: 0,
            padding: '4px 0',
            height: '10px'
          }
        }}
        renderValue={renderValue}
        MenuProps={{
          PaperProps: {
            style: {
              width: '170px'
            }
          }
        }}
      >
        <MenuItem
          value='unverified'
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          Unverified
          <CustomRadio size='small' checked={actualValue === 'unverified'} />
        </MenuItem>
        <MenuItem
          value='verified'
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'space-between'
          }}
        >
          Verified
          <CustomRadio size='small' checked={actualValue === 'verified'} />
        </MenuItem>
      </Select>
    </FormControl>
  );
};
